const SectionTitle = () => import("@/components/SectionTitle/SectionTitle.vue");
const AccountManager = () => import("./AccountManager/AccountManager.vue");
const Agency = () => import("./Agency/Agency.vue");
const AgencyManager = () => import("./Agency/AgencyManager/AgencyManager.vue");

export default {
  components: {
    SectionTitle,
    AccountManager,
    Agency,
    AgencyManager,
  }
};
